const ICE_TRADE = "ICE_TRADE";
const GOS_ZAKUPKI = "GOS_ZAKUPKI";
const BUTB = "BUTB";
const BELOIL = "BELOIL";
const BUTB_PPT = "BUTB_PPT";
const NAFTAN = "NAFTAN";
const MINSKTRANS = "MINSKTRANS";
const BELARUSKALI = "BELARUSKALI";
const BIDMART = "BIDMART";
const BELTRANSGAZ = "BELTRANSGAZ";
const PROXY = "PROXY";
const BECLOUD = "BECLOUD";
const A100 = "A100";
const BELVEB = "BELVEB";
const BUTB_TWS = "BUTB_TWS";
const MTS = "MTS";

export {
  ICE_TRADE,
  GOS_ZAKUPKI,
  BUTB,
  BELOIL,
  BUTB_PPT,
  NAFTAN,
  MINSKTRANS,
  BELARUSKALI,
  BIDMART,
  BELTRANSGAZ,
  PROXY,
  BECLOUD,
  A100,
  BELVEB,
  BUTB_TWS,
  MTS,
};
